import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import clsx from 'clsx';

export interface ContentHeaderProps {
  header?: React.ReactNode;
  subtitle?: React.ReactNode;
  line?: boolean;
  hr?: boolean;
  children?: React.ReactNode;
  icon?: IconProp | null;
  layout?: 'row' | 'column';
  pageHeader?: boolean;
}

export function ContentHeader({
  header = null,
  subtitle = null,
  line = false,
  hr = false,
  children = null,
  icon = null,
  layout = 'column',
  pageHeader = false,
}: ContentHeaderProps) {
  const headerClasses = clsx('header-box__container', {
    'header-box__container--row': layout === 'row',
    'header-box__container--column': layout === 'column',
  });

  return (
    <div className="contentHeader content-header" id="contentHeader">
      <div className={headerClasses}>
        {icon && <FontAwesomeIcon icon={icon} className="icon" />}
        <Typography variant="inherit" component={pageHeader ? 'h1' : 'h3'} className="global__text--title">
          {header}
        </Typography>
      </div>
      {subtitle && (
        <Typography variant="inherit" component={pageHeader ? 'h2' : 'h4'} className="global__text--subtitle">
          {subtitle}
        </Typography>
      )}
      {hr && <hr />}
      {line && <div className="line" />}
      {children}
    </div>
  );
}
